import { render, staticRenderFns } from "./share_dialog.vue?vue&type=template&id=7480e4be&scoped=true"
import script from "./share_dialog.vue?vue&type=script&lang=js"
export * from "./share_dialog.vue?vue&type=script&lang=js"
import style0 from "./share_dialog.vue?vue&type=style&index=0&id=7480e4be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480e4be",
  null
  
)

export default component.exports